let productsOnPage = document.querySelector('.js--products-on-page');
let productCountElement = document.querySelector('.js--product-loaded-count');
let totalProductCountElement = document.querySelector(
  '.product-total-count'
).innerText;
const totalProductCountInt = parseInt(totalProductCountElement, 10);
const loadMoreBtn = document.querySelector('.js--load-more-collection__btn');
const loadMoreSpinner = document.querySelector(
  '.load-more-collection__spinner'
);

let initialProductCount = 8;
let loadedProductCount = initialProductCount; // track loaded product count

function loadMoreProducts() {
  loadMoreBtn.style.display = 'none';
  loadMoreSpinner.style.display = 'block';

  let nextUrl = productsOnPage.dataset.nextUrl;

  fetch(nextUrl)
    .then(response => response.text())
    .then(next_page => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(next_page, 'text/html');
      let newProducts = doc.querySelector('.js--products-on-page');

      if (newProducts.dataset.nextUrl) {
        loadMoreBtn.style.display = 'block';
        loadedProductCount += initialProductCount;
      } else {
        loadedProductCount = totalProductCountInt;
        loadMoreBtn.removeEventListener('click', loadMoreProducts);
      }

      productCountElement.textContent = loadedProductCount;

      productsOnPage.dataset.nextUrl = newProducts.dataset.nextUrl;
      productsOnPage.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      loadMoreSpinner.style.display = 'none';
    });
}
loadMoreBtn.addEventListener('click', loadMoreProducts);
